<div class="container-success animate__animated animate__fadeInRight mt-5" [ngClass]="{'type-b': templateSuffix !== ''}">
  <h2> {{ title}} </h2>
  <mat-icon class="circle" > highlight_off </mat-icon>

  <button mat-button class="btn-danger-custom mt-3 " (click)="toHome()">
    Volver a home
  </button>
</div>
